import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './roles/admin/pages/Dashboard';
import Analytics from './roles/admin/pages/Analytics';
import Reports from './roles/admin/pages/Reports';
import Settings from './roles/admin/pages/Settings';
import OnboardBusiness from './roles/admin/pages/OnboardBusiness';
import Advertisement from './roles/admin/pages/Advertisement';
import Login from './Login';
import BusinessDashboard from './roles/business/pages/Dashboard';
import BusinessInvoices from './roles/business/pages/Invoices';
import BusinessCustomers from './roles/business/pages/Customers';
import BusinessCredits from './roles/business/pages/Credits';
import BusinessProfile from './roles/business/pages/Profile';
import BusinessCustomerCampaigns from './roles/business/pages/CustomerCampaigns';
import CustomerPage from './roles/admin/pages/Customer';
import ShopPage from './roles/admin/pages/Shop';
import MainLayout from './components/MainLayout';
import PrivateRoute from './components/PrivateRoute';
import RoleBasedRedirect from './components/RoleBasedRedirect';
import BusinessDetailsAdmin from './roles/admin/pages/BusinessDetails';
import AdAnalytics from './roles/admin/pages/Advertisements';
import BusinessSettings from './roles/business/pages/Settings';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="*"
          element={
            <MainLayout>
              <Routes>
                <Route path="/business/dashboard" element={<PrivateRoute allowedRoles={['business']}><BusinessDashboard /></PrivateRoute>} />
                <Route path="/business/invoices" element={<PrivateRoute allowedRoles={['business']}><BusinessInvoices /></PrivateRoute>} />
                <Route path="/business/customers" element={<PrivateRoute allowedRoles={['business']}><BusinessCustomers /></PrivateRoute>} />
                <Route path="/business/credits" element={<PrivateRoute allowedRoles={['business']}><BusinessCredits /></PrivateRoute>} />
                <Route path="/business/profile" element={<PrivateRoute allowedRoles={['business']}><BusinessProfile /></PrivateRoute>} />
                <Route path="/business/settings" element={<PrivateRoute allowedRoles={['business']}><BusinessSettings /></PrivateRoute>} />
                <Route path="/business/customer-campaigns" element={<PrivateRoute allowedRoles={['business']}><BusinessCustomerCampaigns /></PrivateRoute>} />
                <Route path="/admin/business-details" element={<PrivateRoute allowedRoles={['admin']}><BusinessDetailsAdmin /></PrivateRoute>} />
                <Route path="/admin/advertisements" element={<PrivateRoute allowedRoles={['admin']}><AdAnalytics /></PrivateRoute>} />
                <Route path="/" element={<RoleBasedRedirect />} />
                <Route path="/admin/dashboard" element={<PrivateRoute allowedRoles={['admin']}><Dashboard /></PrivateRoute>} />
                <Route path="/analytics" element={<PrivateRoute allowedRoles={['admin']}><Analytics /></PrivateRoute>} />
                <Route path="/reports" element={<PrivateRoute allowedRoles={['admin']}><Reports /></PrivateRoute>} />
                <Route path="/settings" element={<PrivateRoute allowedRoles={['admin']}><Settings /></PrivateRoute>} />
                <Route path="/onboard-business" element={<PrivateRoute allowedRoles={['admin']}><OnboardBusiness /></PrivateRoute>} />
                <Route path="/advertisement" element={<PrivateRoute allowedRoles={['admin']}><Advertisement /></PrivateRoute>} />
                <Route path="/customers/:customerNumber" element={<PrivateRoute allowedRoles={['admin']}><CustomerPage /></PrivateRoute>} />
                <Route path="/shops/:shopId" element={<PrivateRoute allowedRoles={['admin']}><ShopPage /></PrivateRoute>} />
                <Route path="*" element={<RoleBasedRedirect />} />
              </Routes>
            </MainLayout>
          }
        />
      </Routes>
    </Router>
  );
}
